import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createMaterialTopTabNavigator } from 'react-navigation-tabs';
import { StyleSheet } from 'react-native';

import { Tabs, Tab, closeAllModals } from '../ui';
import TrackingScanStatsTile from '../Tracking/tracking-scan-stats';
import HealthStatsHistoryScreen from './HealthStatsHistoryScreen';

const ScanStatsTabNavigation = createMaterialTopTabNavigator({
  History: {
    screen: HealthStatsHistoryScreen,
    navigationOptions: {
      tabBarLabel: 'History',
    }
  },
  BodyScans: {
    screen: TrackingScanStatsTile,
    navigationOptions: {
      tabBarLabel: 'Detail',
    }
  },
}, {
    lazy: true,
    swipeEnabled: true,
    backBehavior: 'none',
    tabBarPosition: 'top',
    tabBarComponent: props => (
      <StatsTabWrapped {...props} />
    ),
  });

class StatsTabs extends Component {
  render() {
    const navigation = this.props.navigation;
    const { routes, index } = this.props.navigation.state;

    return (
      <Tabs>
        {routes.map((route, idx) => {
          const active = index === idx;
          const icon = this.props.renderIcon({
            route,
            focused: active,
            index,
          });
          const title = this.props.getLabelText({
            route,
            focused: active,
            index,
          })
          return (
            <Tab
              icon={icon}
              active={active}
              currentTabIndex={idx}
              key={route.routeName}
              title={title}
              useDarkTheme={false}
              amountOfTabs={routes.length - 1}
              onPress={() => {
                this.props.closeAllModals();
                navigation.navigate(route.routeName);
              }}
            />
          );
        })}
      </Tabs>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeAllModals: () => dispatch(closeAllModals()),
  }
}

const StatsTabWrapped = connect(null, mapDispatchToProps)(StatsTabs);

const styles = StyleSheet.create({
  iconContainer: {
    marginRight: 10,
  }
});

export default ScanStatsTabNavigation;
